import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { IEmploymentStatementState } from "./types";
import { IIDAStore } from "../types";
import { EmploymentStatement } from "../../models/employmentStatements";
import { employmentStatementsService } from "../../services/EmploymentStatements.service";
import { Employment } from "../../models/employments";

export const getInitialState = (): IEmploymentStatementState => {
  return {
    searching: false,
    employmentStatements: []
  };
};

const namespaced = true;

export const getters: GetterTree<IEmploymentStatementState, IIDAStore> = {
  GetEmploymentStatementById: (state) => (employmentstatementId: number) => {
    return state.employmentStatements.find(
      (employmentstatement: EmploymentStatement) => employmentstatement.id === employmentstatementId
    );
  },
  GetEmploymentStatementByEmploymentId: (state) => (employmentId: number) => {
    return state.employmentStatements.find(
      (employmentstatement: EmploymentStatement) =>
        employmentstatement.employment_id === employmentId
    );
  }
};

export const actions: ActionTree<IEmploymentStatementState, IIDAStore> = {
  reset({ commit }) {
    commit("reset");
  },
  fetchEmploymentStatementsByEmployeeId(
    { commit, state },
    query: { employeeId: number }
  ): Promise<EmploymentStatement[]> {
    return new Promise((resolve, reject) => {
      if (
        state.employmentStatements.filter((es) => es.employeeId === query.employeeId).length === 0
      ) {
        try {
          employmentStatementsService
            .fetchEmployementStatementByEmployeeId(query.employeeId)
            .then((employmentStatements) => {
              employmentStatements.forEach((es) => {
                es.employeeId = query.employeeId;
              });
              commit("updateEmploymentStatements", { employmentStatements });
              return resolve(employmentStatements);
            });
        } catch (error) {
          return reject(error);
        }
      } else {
        const employmentStatements = state.employmentStatements.filter(
          (es) => es.employeeId === query.employeeId
        );
        return resolve(employmentStatements);
      }
    });
  },
  createEmploymentStatement(
    { commit },
    query: {
      employment: Employment;
      employmentStatement: EmploymentStatement;
      overtime: boolean;
      isOK11: boolean;
      isHourlyPaid: boolean;
      useEmploymentSoCalculation: boolean;
    }
  ): Promise<EmploymentStatement> {
    return new Promise((resolve, reject) => {
      employmentStatementsService
        .createEmploymentStatement(
          query.employmentStatement,
          query.overtime,
          query.isOK11,
          query.isHourlyPaid,
          query.useEmploymentSoCalculation
        )
        .then((newEmploymentStatement) => {
          query.employment.locked = true;
          commit("employments/updateEmployment", query.employment, { root: true });
          newEmploymentStatement.employeeId = query.employmentStatement.employeeId;
          commit("insertEmploymentStatement", newEmploymentStatement);
          resolve(newEmploymentStatement);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteEmploymentStatement(
    { commit },
    query: { employment: Employment; employmentStatementId: number }
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      employmentStatementsService
        .deleteEmploymentStatement(query.employmentStatementId)
        .then((response) => {
          query.employment.locked = false;
          commit("employments/updateEmployment", query.employment, { root: true });
          commit("deleteEmploymentStatement", query.employmentStatementId);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export const mutations: MutationTree<IEmploymentStatementState> = {
  reset(state: IEmploymentStatementState) {
    Object.assign(state, getInitialState());
  },
  insertEmploymentStatement(
    state: IEmploymentStatementState,
    employmentstatement: EmploymentStatement
  ) {
    state.employmentStatements.push(employmentstatement);
  },
  deleteEmploymentStatement(state: IEmploymentStatementState, employmentstatementId: number) {
    const index = state.employmentStatements.findIndex((d) => d.id === employmentstatementId);
    state.employmentStatements.splice(index, 1);
  },
  updateEmploymentStatements(
    state: IEmploymentStatementState,
    payload: { employmentStatements: EmploymentStatement[] }
  ) {
    state.employmentStatements = [
      ...state.employmentStatements,
      ...payload.employmentStatements.filter(
        (newEmploymentStatements) =>
          !state.employmentStatements.find((existing) => existing.equals(newEmploymentStatements))
      )
    ];
  }
};

export const employmentStatementsStoreModule: Module<IEmploymentStatementState, IIDAStore> = {
  namespaced: namespaced,
  state: getInitialState(),
  getters: getters,
  actions: actions,
  mutations: mutations
};
